// components/CustomDropdown.tsx
import React, { useState, useRef, useEffect } from "react";
import arrowDown from "/arrow_dropdown_black.svg";

interface Option {
  label: string;
  value: string;
}

interface CustomDropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  value,
  onChange,
  options,
  placeholder = "Select an option",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find((o) => o.value === value)?.label;

  return (
    <div className="relative" ref={ref}>
      <div
        onClick={() => !disabled && setIsOpen(!isOpen)}
        className={`h-[2.25rem] 2xl:h-10 px-4 border rounded-md flex items-center justify-between transition bg-[#F2F4F7] ${
          disabled
            ? " text-slate-400 cursor-not-allowed border-gray-200"
            : " cursor-pointer border-gray-300 hover:border-blue-500"
        }`}
      >
        <span
          className={`truncate text-sm 2xl:text-base ${
            value ? "text-gray-800" : "text-gray-400"
          }`}
        >
          {selectedLabel || placeholder}
        </span>
        <img src={arrowDown} alt="Dropdown" className="w-3 ml-2" />
      </div>

      {isOpen && !disabled && (
        <ul className="absolute mt-1 w-full z-20 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto text-sm">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 transition ${
                value === option.value ? "bg-gray-50 font-semibold" : ""
              }`}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
